import {
  Archive,
  ArchiveRestore,
  ArchiveX,
  ArrowDownToLine,
  ArrowUpToLine,
  AtSign,
  Award,
  BadgeDollarSign,
  Ban,
  Bell,
  Blend,
  BookOpen,
  Bookmark,
  BookmarkCheck,
  BotMessageSquare,
  BrainCircuit,
  BrickWallShield,
  Bug,
  Building,
  CalendarClock,
  CalendarFold,
  CalendarX,
  CameraOff,
  ChessKing,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheck,
  CirclePlus,
  CircleSlash,
  CircleX,
  ClipboardClock,
  ClockArrowDown,
  CloudDownload,
  Columns2,
  Copy,
  CreditCard,
  Crown,
  Download,
  EllipsisVertical,
  ExternalLink,
  Eye,
  EyeClosed,
  EyeOff,
  File,
  FileArchive,
  FileCheck,
  FileDown,
  FileExclamationPoint,
  FileHeart,
  FileInput,
  FileKey,
  FilePenLine,
  FilePlus,
  FileSearch,
  FileSliders,
  FileSymlink,
  FileUp,
  FileUser,
  FileVolume,
  FileX,
  Files,
  Folder,
  FolderClock,
  FolderInput,
  FolderKey,
  FolderOutput,
  FolderSearch,
  FolderSymlink,
  FolderSync,
  FolderUp,
  Forward,
  Fullscreen,
  GalleryHorizontal,
  GalleryVertical,
  Globe,
  Hammer,
  Hand,
  HardDrive,
  HardDriveDownload,
  Hash,
  HatGlasses,
  Hd,
  History,
  Image,
  ImageUp,
  Inbox,
  Info,
  Key,
  KeyRound,
  KeySquare,
  Keyboard,
  KeyboardOff,
  LayoutDashboard,
  LayoutGrid,
  LayoutList,
  Link,
  List,
  ListChecks,
  ListFilter,
  Loader,
  Lock,
  LockOpen,
  LogOut,
  Logs,
  Mail,
  MailPlus,
  Maximize,
  Menu,
  MessageSquarePlus,
  Monitor,
  Moon,
  MousePointer,
  PackageSearch,
  PanelLeft,
  PanelRightClose,
  PanelRightOpen,
  PanelTop,
  Paperclip,
  Pause,
  Pencil,
  Phone,
  Play,
  Printer,
  Rabbit,
  RectangleEllipsis,
  Replace,
  Reply,
  ReplyAll,
  RotateCcw,
  RotateCw,
  Save,
  ScanFace,
  ScanText,
  Search,
  Send,
  ServerCrash,
  Settings,
  Shapes,
  Share,
  Share2,
  ShieldAlert,
  ShieldBan,
  ShieldCheck,
  ShieldEllipsis,
  ShieldOff,
  ShieldUser,
  Signature,
  SkipBack,
  SkipForward,
  SquareArrowOutUpRight,
  SquareAsterisk,
  SquareCheckBig,
  SquarePen,
  SquareUser,
  SquareX,
  Stamp,
  Star,
  StarOff,
  Store,
  Sun,
  SwatchBook,
  Tag,
  Tags,
  Trash,
  TriangleAlert,
  Type,
  Unplug,
  User,
  UserCheck,
  UserCog,
  UserPen,
  UserPlus,
  UserSearch,
  UserStar,
  UserX,
  Users,
  Video,
  View,
  Volume1,
  Volume2,
  VolumeOff,
  Waypoints,
  WholeWord,
  X,
  ZoomIn,
  ZoomOut,
} from 'lucide-react';
import AdminIcon from '../../../assets/icons/icon-admin.svg';
import AiFileIcon from '../../../assets/icons/icon-file-ai.svg';
import AudioFileIcon from '../../../assets/icons/icon-file-audio.svg';
import CadFileIcon from '../../../assets/icons/icon-file-cad.svg';
import CertifiedTimestampingIcon from '../../../assets/icons/icon-certified-timestamping.svg';
import CodeFileIcon from '../../../assets/icons/icon-file-code.svg';
import ContributorIcon from '../../../assets/icons/icon-contributor.svg';
import ContributorStorageLimitIcon from '../../../assets/icons/icon-contributor-storage-limit.svg';
import DeviceAccessLimitationIcon from '../../../assets/icons/icon-device-access-limitation.svg';
import DocumentsFileIcon from '../../../assets/icons/icon-file-documents.svg';
import DownloadRestrictionsIcon from '../../../assets/icons/icon-download-restrictions.svg';
import EditorFileManagementIcon from '../../../assets/icons/icon-editor-file-management.svg';
import ExcelFileIcon from '../../../assets/icons/icon-file-excel.svg';
import ExternalAccessLinkIcon from '../../../assets/icons/icon-external-access-link.svg';
import ExternalFileSharingRestrictionIcon from '../../../assets/icons/icon-external-file-sharing-restriction.svg';
import FileAutoDeletionIcon from '../../../assets/icons/icon-file-autodeletion.svg';
import FileSalesPermissionIcon from '../../../assets/icons/icon-file-sales-permission.svg';
import FileSizeLimitIcon from '../../../assets/icons/icon-file-size-limit.svg';
import FilegrantEnterpriseLogoExtended from '../../../assets/images/filegrant-enterprise-logo-extended.svg';
import FilegrantLogo from '../../../assets/images/filegrant-logo.svg';
import FilegrantLogoWhite from '../../../assets/images/filegrant-logo-white.svg';
import FolderCreationPermissionIcon from '../../../assets/icons/icon-folder-creation-permission.svg';
import GifFileIcon from '../../../assets/icons/icon-file-gif.svg';
import GroupCreationControlIcon from '../../../assets/icons/icon-group-creation-control.svg';
import ImagesFileIcon from '../../../assets/icons/icon-file-images.svg';
import MSOfficeControlIcon from '../../../assets/icons/icon-msoffice-control.svg';
import NavArchiveIcon from '../../../assets/icons/icon-nav-archive.svg';
import IconFolder from '../../../assets/icons/icon-folder.svg';
import NewFolderIcon from '../../../assets/icons/icon-new-folder.svg';
import NotFoundIllustration from '../../../assets/images/illustration-not-found.svg';
import PdfFileIcon from '../../../assets/icons/icon-file-pdf.svg';
import PngFileIcon from '../../../assets/icons/icon-file-png.svg';
import PptFileIcon from '../../../assets/icons/icon-file-ppt.svg';
import PreviewEmptyIcon from '../../../assets/icons/icon-preview-empty.svg';
import ProfilePictureIcon from '../../../assets/icons/icon-profile-picture.svg';
import PsdFileIcon from '../../../assets/icons/icon-file-psd.svg';
import ReadOnlyIcon from '../../../assets/icons/icon-read-only.svg';
import ReaderIcon from '../../../assets/icons/icon-reader.svg';
import RemotegrantFileIcon from '../../../assets/icons/icon-remotegrant-file.svg';
import SessionControlIcon from '../../../assets/icons/icon-session-control.svg';
import ShieldDownloadIcon from '../../../assets/icons/icon-download-shield.svg';
import SingleSignOnIcon from '../../../assets/icons/icon-single-signon.svg';
import StarShadowIcon from '../../../assets/icons/icon-star-shadow.svg';
import TagBasedSharingRestrictionIcon from '../../../assets/icons/icon-tag-based-sharing-restriction.svg';
import TagEmptyIcon from '../../../assets/icons/icon-tag-empty.svg';
import TagFullIcon from '../../../assets/icons/icon-tag-full.svg';
import UnknownFileIcon from '../../../assets/icons/icon-file-unknown.svg';
import UploadWithTagIcon from '../../../assets/icons/icon-upload-with-tag.svg';
import UserAtIcon from '../../../assets/icons/icon-user-at.svg';
import UserDeniedIcon from '../../../assets/icons/icon-user-denied.svg';
import UserRemoveIcon from '../../../assets/icons/icon-user-remove.svg';
import UsersEditIcon from '../../../assets/icons/icon-users-edit.svg';
import UsersRemoveIcon from '../../../assets/icons/icon-users-remove.svg';
import VideoFileIcon from '../../../assets/icons/icon-file-video.svg';
import ViewTrackingIcon from '../../../assets/icons/icon-view-tracking.svg';
import WatermarkProtectionIcon from '../../../assets/icons/icon-watermark-protection.svg';
import WordFileIcon from '../../../assets/icons/icon-file-word.svg';
import PlugWithErrorIcon from '../../../assets/icons/plug-with-error-icon.svg';
import ReplaceFileIcon from '../../../assets/icons/replace-file-icon.svg';
import StarFullIcon from '../../../assets/icons/star-full-icon.svg';
import MicrosoftEntraIDIcon from '../../../assets/icons/microsoft-entra-id-icon.svg';
import GoogleLogoIcon from '../../../assets/icons/google-logo-icon.svg';
import MicrosoftLogoIcon from '../../../assets/icons/microsoft-logo-icon.svg';
import CybergrantLogoIcon from '../../../assets/icons/cybergrant-logo-icon.svg';
import TagAiLoaderIcon from '../../../assets/icons/tag-ai-loader-icon.svg';
import TagAICheckIcon from '../../../assets/icons/tag-ai-check-icon.svg';
import TagAiTriangleAlertIcon from '../../../assets/icons/tag-ai-triangle-alert-icon.svg';
import TagAiIcon from '../../../assets/icons/tag-ai-icon.svg';
import UsersPlusIcon from '../../../assets/icons/users-plus-icon.svg';
import FilegrantIconLogo from '../../../assets/images/filegrant-icon-logo.svg';
import FolderFilledIcon from '../../../assets/icons/folder-filled-icon.svg';
import FolderFilledLockIcon from '../../../assets/icons/folder-filled-lock-icon.svg';
import FolderFilledLockOpenIcon from '../../../assets/icons/folder-filled-lock-open-icon.svg';

export const iconComponents = {
  UserPlusIcon: UserPlus,
  AdminIcon,
  AiFileIcon,
  ArchiveIcon: Archive,
  AudioFileIcon,
  CadFileIcon,
  CertifiedTimestampingIcon,
  CodeFileIcon,
  ContributorIcon,
  ContributorStorageLimitIcon,
  DeviceAccessLimitationIcon,
  DocumentsFileIcon,
  CloudDownloadIcon: CloudDownload,
  DownloadRestrictionsIcon,
  EditorFileManagementIcon,
  ExcelFileIcon,
  ExternalAccessLinkIcon,
  ExternalFileSharingRestrictionIcon,
  EyeOffIcon: EyeOff,
  EyeIcon: Eye,
  FileAutoDeletionIcon,
  FileSalesPermissionIcon,
  FileSizeLimitIcon,
  FilegrantEnterpriseLogoExtended,
  FilegrantLogo,
  FilegrantLogoWhite,
  FolderCreationPermissionIcon,
  GifFileIcon,
  GroupCreationControlIcon,
  ImageIcon: Image,
  ImagesFileIcon,
  ListIcon: List,
  MSOfficeControlIcon,
  MenuIcon: Menu,
  NavArchiveIcon,
  FileHeartIcon: FileHeart,
  IconFolder,
  UsersIcon: Users,
  SettingsIcon: Settings,
  FileUserIcon: FileUser,
  TrashIcon: Trash,
  UserIcon: User,
  NewFolderIcon,
  NotFoundIllustration,
  SquareArrowOutUpRight: SquareArrowOutUpRight,
  PdfFileIcon,
  PngFileIcon,
  PptFileIcon,
  PreviewEmptyIcon,
  ProfilePictureIcon,
  PsdFileIcon,
  ChevronDownIcon: ChevronDown,
  ReadOnlyIcon,
  ReaderIcon,
  RemotegrantFileIcon,
  SessionControlIcon,
  ShieldDownloadIcon,
  SingleSignOnIcon,
  StarShadowIcon,
  TagBasedSharingRestrictionIcon,
  TagEmptyIcon,
  TagFullIcon,
  TagIcon: Tag,
  UnknownFileIcon,
  UploadWithTagIcon,
  UserAtIcon,
  UserDeniedIcon,
  SearchIcon: Search,
  UserPenIcon: UserPen,
  UserRemoveIcon,
  UsersEditIcon,
  UsersRemoveIcon,
  VideoFileIcon,
  VideoIcon: Video,
  ViewTrackingIcon,
  WatermarkProtectionIcon,
  WordFileIcon,
  XIcon: X,
  FileArchiveIcon: FileArchive,
  CameraOffIcon: CameraOff,
  TriangleAlertIcon: TriangleAlert,
  TypeIcon: Type,
  ServerCrashIcon: ServerCrash,
  PlugWithErrorIcon,
  CircleCheckIcon: CircleCheck,
  BuildingIcon: Building,
  ReplaceFileIcon,
  ReplyIcon: Reply,
  ReplyAllIcon: ReplyAll,
  ForwardIcon: Forward,
  FileSymlinkIcon: FileSymlink,
  ExternalLinkIcon: ExternalLink,
  ChevronRightIcon: ChevronRight,
  AtSignIcon: AtSign,
  CalendarFoldIcon: CalendarFold,
  FileSlidersIcon: FileSliders,
  AwardIcon: Award,
  LockIcon: Lock,
  FolderIcon: Folder,
  FileInputIcon: FileInput,
  UserXIcon: UserX,
  UserCheckIcon: UserCheck,
  UserCogIcon: UserCog,
  FileDownIcon: FileDown,
  FileUpIcon: FileUp,
  FolderUpIcon: FolderUp,
  FilePenLineIcon: FilePenLine,
  FolderInputIcon: FolderInput,
  FilesIcon: Files,
  ReplaceIcon: Replace,
  ArchiveRestoreIcon: ArchiveRestore,
  ArchiveXIcon: ArchiveX,
  ShieldCheckIcon: ShieldCheck,
  FolderOutputIcon: FolderOutput,
  StarOffIcon: StarOff,
  StarIcon: Star,
  FilePlusIcon: FilePlus,
  LayoutListIcon: LayoutList,
  LayoutGridIcon: LayoutGrid,
  SwatchBookIcon: SwatchBook,
  PencilIcon: Pencil,
  PhoneIcon: Phone,
  EllipsisVerticalIcon: EllipsisVertical,
  BookmarkIcon: Bookmark,
  BookmarkCheckIcon: BookmarkCheck,
  StarFullIcon,
  ChevronLeftIcon: ChevronLeft,
  PanelRightOpenIcon: PanelRightOpen,
  PanelRightCloseIcon: PanelRightClose,
  CalendarClockIcon: CalendarClock,
  CopyIcon: Copy,
  ListFilterIcon: ListFilter,
  UnplugIcon: Unplug,
  CircleXIcon: CircleX,
  MaximizeIcon: Maximize,
  VolumeOffIcon: VolumeOff,
  Volume2Icon: Volume2,
  FolderSymlinkIcon: FolderSymlink,
  SquareCheckBigIcon: SquareCheckBig,
  StoreIcon: Store,
  SquarePenIcon: SquarePen,
  ViewIcon: View,
  InfoIcon: Info,
  MicrosoftEntraIDIcon,
  LoaderIcon: Loader,
  BrainCircuitIcon: BrainCircuit,
  KeySquareIcon: KeySquare,
  GoogleLogoIcon,
  MicrosoftLogoIcon,
  CybergrantLogoIcon,
  ScanTextIcon: ScanText,
  BotMessageSquareIcon: BotMessageSquare,
  TagsIcon: Tags,
  SendIcon: Send,
  FileXIcon: FileX,
  LogsIcon: Logs,
  MessageSquarePlusIcon: MessageSquarePlus,
  SquareUserIcon: SquareUser,
  ImageUpIcon: ImageUp,
  ShieldUserIcon: ShieldUser,
  FileSearchIcon: FileSearch,
  TagAiLoaderIcon,
  TagAICheckIcon,
  TagAiTriangleAlertIcon,
  TagAiIcon,
  BadgeDollarSignIcon: BadgeDollarSign,
  UsersPlusIcon,
  CircleAlertIcon: CircleAlert,
  CirclePlusIcon: CirclePlus,
  WaypointsIcon: Waypoints,
  UserStarIcon: UserStar,
  BlendIcon: Blend,
  SaveIcon: Save,
  SignatureIcon: Signature,
  HistoryIcon: History,
  PlayIcon: Play,
  PauseIcon: Pause,
  Volume1Icon: Volume1,
  FileVolumeIcon: FileVolume,
  RotateCcwIcon: RotateCcw,
  RotateCwIcon: RotateCw,
  SkipBackIcon: SkipBack,
  SkipForwardIcon: SkipForward,
  CrownIcon: Crown,
  BookOpenIcon: BookOpen,
  CalendarXIcon: CalendarX,
  FileKeyIcon: FileKey,
  ZoomInIcon: ZoomIn,
  ZoomOutIcon: ZoomOut,
  FullscreenIcon: Fullscreen,
  PrinterIcon: Printer,
  MoonIcon: Moon,
  MonitorIcon: Monitor,
  SunIcon: Sun,
  Columns2Icon: Columns2,
  ChevronUpIcon: ChevronUp,
  PanelLeftIcon: PanelLeft,
  GalleryVerticalIcon: GalleryVertical,
  GalleryHorizontalIcon: GalleryHorizontal,
  HandIcon: Hand,
  MousePointerIcon: MousePointer,
  ArrowUpToLineIcon: ArrowUpToLine,
  ArrowDownToLineIcon: ArrowDownToLine,
  FilegrantIconLogo,
  GlobeIcon: Globe,
  ShareIcon: Share,
  Share2Icon: Share2,
  DownloadIcon: Download,
  HardDriveDownloadIcon: HardDriveDownload,
  HardDriveIcon: HardDrive,
  ClockArrowDownIcon: ClockArrowDown,
  PanelTopIcon: PanelTop,
  BellIcon: Bell,
  ListChecksIcon: ListChecks,
  FileCheckIcon: FileCheck,
  ShapesIcon: Shapes,
  EyeClosedIcon: EyeClosed,
  SquareXIcon: SquareX,
  FolderSearchIcon: FolderSearch,
  UserSearchIcon: UserSearch,
  ClipboardClockIcon: ClipboardClock,
  BanIcon: Ban,
  WholeWordIcon: WholeWord,
  SquareAsteriskIcon: SquareAsterisk,
  FileIcon: File,
  FileExclamationPointIcon: FileExclamationPoint,
  LayoutDashboardIcon: LayoutDashboard,
  ChessKingIcon: ChessKing,
  BrickWallShieldIcon: BrickWallShield,
  HammerIcon: Hammer,
  HashIcon: Hash,
  FolderKeyIcon: FolderKey,
  LockOpenIcon: LockOpen,
  FolderFilledIcon,
  FolderFilledLockIcon,
  FolderFilledLockOpenIcon,
  RectangleEllipsisIcon: RectangleEllipsis,
  KeyIcon: Key,
  KeyRoundIcon: KeyRound,
  CreditCardIcon: CreditCard,
  LinkIcon: Link,
  StampIcon: Stamp,
  PackageSearchIcon: PackageSearch,
  KeyboardIcon: Keyboard,
  KeyboardOffIcon: KeyboardOff,
  FolderClockIcon: FolderClock,
  LogOutIcon: LogOut,
  MailIcon: Mail,
  InboxIcon: Inbox,
  MailPlusIcon: MailPlus,
  PaperclipIcon: Paperclip,
  RabbitIcon: Rabbit,
  CircleSlashIcon: CircleSlash,
  ScanFaceIcon: ScanFace,
  ShieldBanIcon: ShieldBan,
  ShieldEllipsisIcon: ShieldEllipsis,
  ShieldOffIcon: ShieldOff,
  ShieldAlertIcon: ShieldAlert,
  HatGlassesIcon: HatGlasses,
  FolderSyncIcon: FolderSync,
  BugIcon: Bug,
  HdIcon: Hd,
};
